import chroma, { Color } from 'chroma-js';

function hexToRgb(color: string | number | Color) {
    return chroma(color).rgb().join(', ');
}

export default hexToRgb;
